import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel } from "swiper/modules";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import MediaCarouselItem from "./item";
import Image from "components/image";
import clsx from "clsx/lite";

const MediaCarousel = ({ data, pageSettings, index: moduleIndex }) => {
	const isSlider = data.items?.filter(item => !item.hideSlide)?.length > 1 && !data.disableSwiper;
	const firstVisibleIndex = data.items?.findIndex((item) => !item.hideSlide);
	const listBgColor = { backgroundColor: data.listBgColor?.hex };
	const { embedHeader } = pageSettings || {};

	const swiperSettings = isSlider
		? {
			modules: [Navigation, Mousewheel],
			slidesPerView: 1,
			speed: 800,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			navigation: {
				enabled: true,
				nextEl: ".right-arrow-an",
				prevEl: ".left-arrow-an",
			},
		}
		: {};

	return (
		<div className={clsx("max-h-fit", (embedHeader && moduleIndex === 0) && "mt-[-144px] lg:mt-[-156px]")}>
			{data?.highlightedList &&
				<div style={listBgColor}
					className="highlighted-list p-2 md:p-2.5 flex text-black justify-center items-center gap-2 md:gap-12 flex-wrap mt-1">
					{data.highlightedList?.map((list, index) => (
						<div key={index}
							className="flex items-center gap-1.5 md:gap-3 border-r border-black pr-2 md:pr-12 last:border-0 last:pr-0">
							<div className="size-4 md:size-6 flex items-center">
								<Image image={list.icon} />
							</div>
							<span className="text-xs md:text-sm">{list.text}</span>
						</div>
					))}
				</div>}
			<Swiper {...swiperSettings} className={clsx(data?.highlightedList && "media-with-list")}>
				{data?.items?.map((item, index) => {
					if (item.hideSlide) return null;
					return (
						<SwiperSlide key={index} className="w-full">
							<MediaCarouselItem item={item}
								limitHeight={data.limitHeight}
								isFirst={index === firstVisibleIndex}
								embedHeader={embedHeader && moduleIndex === 0} />
						</SwiperSlide>
					);
				})}
				{isSlider && (
					<>
						<button className="left-arrow-an pl:2 md:pl-5">
							<Arrow className="invert rotate-180" />
						</button>
						<button className="right-arrow-an pr-2 md:pr-5">
							<Arrow className="invert" />
						</button>
					</>
				)}
			</Swiper>
		</div>
	);
};

export default MediaCarousel;